import React, { Component } from "react";

import { getUser } from "../helper/user_helper";
import { getListFromName } from "../helper/list_helper";
import { renderErrorMessage } from "../helper/user_helper";

import Loader from "../components/loader";
import ListOfQuestionPage from "../components/list/list_of_question_page";

class List extends Component {
  state = { list_name: null, loaded: false, errors: "", list: null };

  constructor(props) {
    super(props);
    this.state = {
      list_name: props.match.params.id,
      loaded: false,
      errors: "",
      list: null,
      signedIn: false,
      user: null,
      invite_giveaway: null
    };
  }

  componentDidMount() {
    // Check if user is already login
    const self = this;
    this.userCall = getUser();
    this.userCall.promise.then(answer => {
      if (answer.signedIn === true) {
        self.setState({ signedIn: true, user: answer.user });
      }
    });
    this.getList();
  }

  componentWillUnmount() {
    if (this.userCall) {
      this.userCall.cancel();
    }
    if (this.getListCall) {
      this.getListCall.cancel();
    }
  }

  componentDidUpdate() {
    if (this.props.match.params.id !== this.state.list_name) {
      this.setState({
        list_name: this.props.match.params.id
      });
      this.getList();
    }
  }

  render() {
    return <div className="">{this.renderList()}</div>;
  }

  renderList() {
    if (this.state.loaded === false) {
      return <Loader loaded={this.state.loaded} />;
    }
    if (this.state.errors !== "") {
      return <div>{renderErrorMessage(this.state.errors)}</div>;
    }
    return (
      <ListOfQuestionPage
        list={this.state.list}
        addAnswer={this.addAnswer}
        removeAnswer={this.removeAnswer}
        updateAnswer={this.updateAnswer}
        history={this.props.history}
        user={this.state.user}
        reloadList={this.getList}
        seeAnswers={this.seeAnswers}
        invite_giveaway={this.state.invite_giveaway}
      />
    );
  }

  getList = e => {
    const self = this;
    self.setState({ loaded: false, errors: "", list: null });
    this.getListCall = getListFromName(this.props.match.params.id);
    this.getListCall.promise
      .then(answer => {
        self.setState({
          loaded: true,
          list: answer.list,
          invite_giveaway: answer.invite_giveaway
        });
      })
      .catch(error => {
        self.setState({ loaded: true, errors: error.errors });
      });
  };

  addAnswer = (answer, question) => {
    const questions = [...this.state.list.questions];
    const index = questions.indexOf(question);
    questions[index] = { ...question };
    questions[index].already_comment = true;
    var answers = [...questions[index].answers];
    answers.push(answer);
    questions[index].answers = answers;
    const list = { ...this.state.list };
    list.questions = questions;
    this.setState({ list });
  };

  removeAnswer = answer => {
    const questions = [...this.state.list.questions];
    for (var question_id in questions) {
      var answers = [...questions[question_id].answers];
      for (var answer_id in answers) {
        if (answers[answer_id].id === answer.id) {
          answers.splice(answer_id, 1);
          questions[question_id].answers = answers;
          break;
        }
      }
    }

    const list = { ...this.state.list };
    list.questions = questions;
    this.setState({ list });
  };

  updateAnswer = answer => {
    const questions = [...this.state.list.questions];
    for (var question_id in questions) {
      var answers = [...questions[question_id].answers];
      for (var answer_id in answers) {
        if (answers[answer_id].id === answer.id) {
          answers[answer_id] = answer;
          questions[question_id].answers = answers;
          break;
        }
      }
    }

    const list = { ...this.state.list };
    list.questions = questions;
    this.setState({ list });
  };

  seeAnswers = e => {
    const list = { ...this.state.list };
    list.already_comment = true;
    this.setState({ list });
  };
}

export default List;



// WEBPACK FOOTER //
// ./src/pages/list.jsx